import React, { PropTypes } from 'react';
import EditPopup from './EditPopup.jsx';
import NewPopup from './NewPopup.jsx';

const Popup = (props)=> {
    const renderModal = ()=> {
        if (props.popupMode === "edit") {
            return (
            <EditPopup title={props.draft.title} desc={props.draft.description} onSave={props.onSave} onCancel={props.onCancel}/>
            )
        } else {
            return( <NewPopup onSave={props.onSaveNew} onCancel={props.onCancel}/>)
        }
    };
    const showModal = ()=> {
            return (
                setTimeout(function() {
                    document.getElementById('pop-up').className += ' is-opened';
                    console.log(document.getElementById('pop-up').className)
                }, 50)
            )
    };

    return (
        <div id="pop-up" className="pop-up">
            <div className="pop-up__background" onClick={props.onCancel}></div>
            {renderModal()}
            {showModal()}
        </div>
    )
};

Popup.propTypes = {
    draft: PropTypes.object,
    title: PropTypes.string,
    desc: PropTypes.string,
    onCancel: PropTypes.func
};

Popup.defaultProps = {
    title: '',
    desc: ''
};

export default Popup;


// WEBPACK FOOTER //
// ./src/_app/drafts/components/Popup.jsx